var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_488_723",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0968018,
    y: 0.54834,
    width: 18.5806,
    height: 18.5806,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_488_723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.30333 13.3999L13.7614 7.94184L12.6775 6.85797L8.30333 11.2322L6.09688 9.02571L5.01301 10.1096L8.30333 13.3999ZM9.3872 17.5806C8.31623 17.5806 7.30978 17.3772 6.36784 16.9705C5.42591 16.5643 4.60655 16.0128 3.90978 15.316C3.21301 14.6193 2.66152 13.7999 2.25533 12.858C1.84862 11.916 1.64526 10.9096 1.64526 9.83861C1.64526 8.76765 1.84862 7.7612 2.25533 6.81926C2.66152 5.87733 3.21301 5.05797 3.90978 4.3612C4.60655 3.66442 5.42591 3.11268 6.36784 2.70597C7.30978 2.29978 8.31623 2.09668 9.3872 2.09668C10.4582 2.09668 11.4646 2.29978 12.4066 2.70597C13.3485 3.11268 14.1678 3.66442 14.8646 4.3612C15.5614 5.05797 16.1129 5.87733 16.5191 6.81926C16.9258 7.7612 17.1291 8.76765 17.1291 9.83861C17.1291 10.9096 16.9258 11.916 16.5191 12.858C16.1129 13.7999 15.5614 14.6193 14.8646 15.316C14.1678 16.0128 13.3485 16.5643 12.4066 16.9705C11.4646 17.3772 10.4582 17.5806 9.3872 17.5806Z",
    fill: "#24B562"
  }))));
}

export default __webpack_public_path__ + "media/911222c1.svg";
export { SvgCheckCircle as ReactComponent };